
import * as angular from "angular";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { BroadcastEvent } from "../enum/BroadcastEvent";

export class FilterBarService {

    static $inject = ["$rootScope"];

    constructor(
        private $rootScope: IRunBlockRootScope) {
    }

    //public showFilterBar(): void {
    //    this.$rootScope.$broadcast(BroadcastEvent.showResourceFilterBar, true);
    //}

    //public hideFilterBar(): void {
    //    this.$rootScope.$broadcast(BroadcastEvent.showResourceFilterBar, false);
    //}

    public closeFilterBar(): void {
        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar, false);
    }
}
